module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "InterimPaymentsForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_vm._m(0), _vm._v(" "), (_vm.interimPayments.length === 0) ? _c('p', [_vm._v("\n                    Add details of any Interim Payments using the button below:\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.interimPayments), function(interimPayment, index) {
    return _c('div', {
      staticClass: "dependant a-form-inputs--section"
    }, [_c('payment', {
      attrs: {
        "index": index
      },
      on: {
        "update": _vm.updateValid
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._v("Add Interim Payment")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "a-form-inputs"
  }, [_vm._m(1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Calculate Interest Rates to"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestType),
      expression: "interestType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcInterestValue]
    }
  }, [_c('option', {
    attrs: {
      "value": "today"
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "assumed_settlement"
    }
  }, [_vm._v("Assumed Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("Do Not Calculate")])])]), _vm._v(" "), (_vm.interestType === 'custom') ? _c('control', {
    attrs: {
      "label": "Custom date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "required": _vm.interestType === 'custom'
    },
    on: {
      "input": _vm.calcInterestValue
    },
    model: {
      value: (_vm.customInterestDate),
      callback: function($$v) {
        _vm.customInterestDate = $$v
      },
      expression: "customInterestDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('div', {
    staticClass: "m-div-table__holder m-div-table__holder--less-margin"
  }, [_c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('generalDamagesInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'generalDamages'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('generalDamagesWithInterest'),
      "tip-name": "general_damages_psla",
      "title": "General damages (PSLA)",
      "updates": "generalDamages"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('pastDependencyOnServicesInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastDependencyOnServices'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastDependencyOnServicesWithInterest'),
      "tip-name": "past_dependency_on_services",
      "title": "Past Cost of Services",
      "updates": "pastDependencyOnServices"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('pastLossOfEarningsInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastLossOfEarnings'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastLossOfEarningsWithInterest'),
      "tip-name": "past_loss_of_earnings",
      "title": "Past Loss of Earnings",
      "updates": "pastLossOfEarningsInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "name": "pastCostOfCare",
      "interest": _vm.getHeadsOfLossValue('pastCostOfCareInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastCostOfCare'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastCostOfCareWithInterest'),
      "tip-name": "past_cost_of_care",
      "title": "Past Cost of Care",
      "updates": "pastCostOfCareInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('pastCostOfTravelInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'pastCostOfTravel'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('pastCostOfTravelWithInterest'),
      "tip-name": "past_cost_of_travel",
      "title": "Past Cost of Travel",
      "updates": "pastCostOfTravelInterest"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _c('interest-item', {
    attrs: {
      "interest": _vm.getHeadsOfLossValue('miscInterest'),
      "payload": _vm.payload,
      "option": {
        name: 'misc'
      },
      "unique-id": _vm.uniqueId,
      "value": _vm.getHeadsOfLossValue('miscWithInterest'),
      "tip-name": "miscellaneous",
      "title": "Miscellaneous",
      "updates": "miscellaneous"
    },
    on: {
      "update": _vm.onUpdate
    }
  }), _vm._v(" "), _vm._l((_vm.allCustomHeadOfLoss), function(headOfLoss, key) {
    return _c('interest-item', {
      attrs: {
        "interest": headOfLoss.interest,
        "payload": _vm.payload,
        "option": {
          name: headOfLoss.name,
          key: key
        },
        "title": headOfLoss.name,
        "unique-id": _vm.uniqueId,
        "updates": key,
        "value": headOfLoss.interestAccrued,
        "tip-name": headOfLoss.name
      },
      on: {
        "update": _vm.onUpdateCustom
      }
    })
  })], 2)])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid() && _vm.allInterimPaymentsValid
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'interest_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Interim Payments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Interest")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ac01b0b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lost-years-claims/steps/InterimPayments.vue
// module id = 1646
// module chunks = 0